import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEPRECATED_TRACKS = [6, 22];
const TrackDeprecatedDescription = ({
  compressed,
  trackId,
  message,
  cta
}) => {
  let learnMoreLink;
  switch (trackId) {
    case 6:
      {
        learnMoreLink = 'https://designers.hubspot.com/blog/were-sunsetting-the-hubspot-design-certification-heres-why';
        break;
      }
    case 22:
      {
        learnMoreLink = 'https://blog.hubspot.com/customers/new-curriculum-inbound-marketing-sales-training';
        break;
      }
    default:
      learnMoreLink = '';
  }
  const noticeToDisplay = DEPRECATED_TRACKS.includes(trackId) ? trackId : 'default';
  if (message) {
    return /*#__PURE__*/_jsxs("div", {
      children: [message, !compressed ? /*#__PURE__*/_jsx("br", {}) : ' ', cta && /*#__PURE__*/_jsx(Link, {
        external: true,
        href: cta,
        onClick: e => {
          e.stopPropagation();
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.learnMore"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `learningCenter.tracks.deprecations.noticesById.${noticeToDisplay}`,
    options: {
      learnMore: /*#__PURE__*/_jsx(Link, {
        external: true,
        href: learnMoreLink,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.learnMore"
        })
      })
    }
  });
};
export default TrackDeprecatedDescription;